var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 655.359,
    height: 655.359,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6.827 6.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#212121;fill-rule:nonzero}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_267725264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_267725312",
    className: "fil0",
    d: "M1.137 1.791h2.747a.283.283 0 0 1 .284.284v2.17a.283.283 0 0 1-.284.283H2.197a.47.47 0 0 0-.069-.214h1.756a.07.07 0 0 0 .05-.02.07.07 0 0 0 .02-.05v-2.17a.07.07 0 0 0-.02-.049.07.07 0 0 0-.05-.02H1.137a.07.07 0 0 0-.05.02.07.07 0 0 0-.02.05v2.17c0 .018.008.036.02.049a.07.07 0 0 0 .05.02h.186a.47.47 0 0 0-.07.214h-.116a.283.283 0 0 1-.284-.284v-2.17a.283.283 0 0 1 .284-.283z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_267725192",
    className: "fil0",
    d: "M4.06 3.334h1.6a.312.312 0 0 1 .313.313v.568a.312.312 0 0 1-.313.313h-.314a.47.47 0 0 0-.069-.214h.383a.1.1 0 0 0 .07-.03.1.1 0 0 0 .03-.07v-.567a.1.1 0 0 0-.03-.07.1.1 0 0 0-.07-.03h-1.6v-.213zm.343 1.194h-.696v-.214h.765a.47.47 0 0 0-.07.214z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_267725144",
    className: "fil0",
    d: "M4.06 2.428a.107.107 0 0 0 0 .213h.71l.54.815a.106.106 0 0 0 .178-.117l-.568-.857a.107.107 0 0 0-.093-.054h-.766z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_267725552",
    className: "fil0",
    d: "M4.874 4.09a.472.472 0 0 1 .335.807.472.472 0 0 1-.808-.335.472.472 0 0 1 .473-.473zm.184.289a.259.259 0 0 0-.443.183.259.259 0 0 0 .443.184.259.259 0 0 0 0-.367z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_267725240",
    className: "fil0",
    d: "M1.726 4.09a.472.472 0 0 1 .334.807.472.472 0 0 1-.808-.335.472.472 0 0 1 .474-.473zm.183.289a.259.259 0 0 0-.443.183.259.259 0 0 0 .443.184.259.259 0 0 0 0-.367z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_267725432",
    className: "fil0",
    d: "M5.867 3.904a.107.107 0 0 0 0-.214h-.474a.107.107 0 0 0 0 .214h.474z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h6.827v6.827H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVms);
export default __webpack_public_path__ + "static/media/vms.9c1bc29e13976e98fa05b5c0b6ff0d21.svg";
export { ForwardRef as ReactComponent };